<script setup lang="ts">
import {
  PhxsgCenter as PhxsgCoreCenter,
  type PhxsgCenterProps as PhxsgCoreCenterProps,
} from '@sg-core/src/View/Components/Atoms/Center';

export interface PhxsgCenterProps extends PhxsgCoreCenterProps {
  spacing?: 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 14 | 18;
  sizing?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
}

defineProps<PhxsgCenterProps>();
</script>

<template>
  <PhxsgCoreCenter v-bind="$props">
    <slot />
  </PhxsgCoreCenter>
</template>
